import { DiagnosticFunnel } from '../../../components/tools/DiagnosticFunnel';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('tertiaire', 'diagnostic-cee')!;

export default function TertiaireDiagnosticCeePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/tertiaire"
        backLabel="Espace tertiaire"
        duration="60 sec"
      >
        <DiagnosticFunnel lockedAudience="tertiaire" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace tertiaire', url: 'https://solutionecofrance.fr/tertiaire' },
          { name: 'Diagnostic CEE', url: 'https://solutionecofrance.fr/tertiaire/diagnostic-cee' },
        ]}
      />
    </>
  );
}
